/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable @typescript-eslint/no-unused-vars, no-restricted-syntax */

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as Types from '../../../types/definitions/vendor/graphql-schema.d';

const defaultOptions = {} as const;

export type DynamicProductAdCreateMutationVariables = Types.Exact<{
  input: Types.DynamicProductAdCreateInput;
}>;

export type DynamicProductAdCreateMutation = {
  __typename?: 'Mutation';
  dynamicProductAdCreate?: {
    __typename?: 'DynamicProductAdCreatePayload';
    result:
      | {
          __typename?: 'DynamicProductAdCreateError';
          code: Types.DynamicProductAdErrorCode;
          message?: string | null;
        }
      | { __typename?: 'DynamicProductAdCreateSuccess'; id: string };
  } | null;
};

export const DynamicProductAdCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'dynamicProductAdCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DynamicProductAdCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dynamicProductAdCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'DynamicProductAdCreateError',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'DynamicProductAdCreateSuccess',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DynamicProductAdCreateMutationFn = Apollo.MutationFunction<
  DynamicProductAdCreateMutation,
  DynamicProductAdCreateMutationVariables
>;

/**
 * __useDynamicProductAdCreateMutation__
 *
 * To run a mutation, you first call `useDynamicProductAdCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDynamicProductAdCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dynamicProductAdCreateMutation, { data, loading, error }] = useDynamicProductAdCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDynamicProductAdCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DynamicProductAdCreateMutation,
    DynamicProductAdCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    DynamicProductAdCreateMutation,
    DynamicProductAdCreateMutationVariables
  >(DynamicProductAdCreateDocument, options);
}
export type DynamicProductAdCreateMutationHookResult = ReturnType<
  typeof useDynamicProductAdCreateMutation
>;
export type DynamicProductAdCreateMutationResult =
  Apollo.MutationResult<DynamicProductAdCreateMutation>;
export type DynamicProductAdCreateMutationOptions = Apollo.BaseMutationOptions<
  DynamicProductAdCreateMutation,
  DynamicProductAdCreateMutationVariables
>;
